import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { Observable, of } from 'rxjs';
import { SetTheme } from '../../store';

@Injectable({ providedIn: 'root' })
export class DiseaseProfilePagesGuard {
  private store = inject<Store<fromStore.DiseaseProfileState>>(Store);


  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  canDeactivate() {
    return this.store.select(fromStore.getDiseaseProfilePagesLoaded).pipe(
      tap(loaded => {
        if (loaded) {
          this.store.dispatch(fromStore.ClearDiseaseProfilePages());
        }
      }),
      filter(loaded => !loaded),
      map(loaded => !loaded),
      take(1)
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getDiseaseProfilePagesLoaded).pipe(
      withLatestFrom(this.store.select(fromRoot.getRouterState)),
      tap(([loaded, router]) => {
        if (!loaded) {
          this.store.dispatch(
            fromStore.LoadDiseaseProfilePages({ id: router.state.params?.['diseaseProfileId'] || router.state.data?.['diseaseProfileId'] })
          );
        }
      }),
      map(([loaded, router]) => loaded),
      filter(loaded => loaded),
      take(1)
    );
  }
}
